module.exports = require("koishi-thirdeye");